import React  from "react";
import { useParams } from 'react-router-dom';
import RegisteredAnimalsForm from "../components/RegisteredAnimalsForm";
import { ANIMAL_TYPE_SHEEP } from "variables/constants";

const EditSheep = () => {
	const { sheepId } = useParams();

	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		<RegisteredAnimalsForm recordId={sheepId ?? 0} mode="edit" animalTypeId={ANIMAL_TYPE_SHEEP}/>
	      </div>
	    </div>
    );
};

export default EditSheep;